import React, { Component } from "react";
import { connect } from "react-redux";

import styles from "./CapacityPlaning.local.scss";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import _ from "i18n";
import {
  setCapacityPlaningFilterSearchWord,
  setClientsDeletedStatus,
  setCapacityPlaningFilterState
} from "Actions";
import { fetchCapacityPlaningProduction } from "Thunks";
import { COLLABORATOR_STATES, DELETED_STATUS } from "Config";

class CapacityPlaningProductionFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };
  }

  handleRefreshCollaboratorList = () => {
    this.props.dispatch(fetchCapacityPlaningProduction());
  };

  handleSearchInputChange(word) {
    this.props.dispatch(setCapacityPlaningFilterSearchWord(word));
    this.handleRefreshCollaboratorList();
  }

  handleSetCapacityPlaningFilterState = selected => {
    this.props.dispatch(setCapacityPlaningFilterState(selected));
    this.handleRefreshCollaboratorList();
  };

  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };

  handleSetDeletedStatus = selectedStatus => {
    this.props.dispatch(setClientsDeletedStatus(selectedStatus));
    this.handleRefreshCollaboratorList();
  };

  handleResetFilter = () => {
    // TODO
  };

  render() {
    let {
      customAddOn,
      filter: { searchWord, collaboratorState },
      fetching,
      listFilters,
      nbResult
    } = this.props;

    let filters = [
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("collaborator state"),
          options: COLLABORATOR_STATES,
          values: collaboratorState,
          action: this.handleSetCapacityPlaningFilterState
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: _("notCollaborator"),
          options: DELETED_STATUS,
          values: listFilters.entityClientId.deletedStatus,
          action: this.handleSetDeletedStatus
        }
      }
    ];

    return (
      <div className="row align-center medium-12">
        <div className={`medium-12 ${styles.filter_bar}`}>
          <TTPFilterHorizontalBar
            button
            filters={filters}
            customAddOn={customAddOn}
            searchPlaceholder="Search by name"
            // handleResetFilter={this.handleResetFilter}
            searchInputValue={searchWord}
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            filterFormIsVisible={this.filterFormIsVisible}
            cssClass="medium-12"
            nbResult={nbResult}
            label={_("collaboratorNumber")}
            marginLeft={"10em"}
            fetching={fetching}
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  lng: state.params.lng,
  filter: state.capacityPlaning.production.filter,
  fetching: state.capacityPlaning.production.fetching,
  listFilters: state.clients.filter,
  nbResult:
    state.capacityPlaning.production.data &&
    state.capacityPlaning.production.data.length
});

export default connect(mapStateToProps)(CapacityPlaningProductionFilter);



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/CapacityPlaningProductionFilter.js